import { Cookie } from "../util/Cookie"

export default class StarsNotifications {
    constructor() {
        this.starProfileCalledFromMyStarsCookie = new Cookie("starProfileCalledFromMyStars", {
            path: "/",
            domain: SiteInfo.cookieDomain,
        })

        this.myStarsNavigationUsedCookie = new Cookie("myStarsNavigationUsed", {
            path: "/",
            domain: SiteInfo.cookieDomain,
        })

        this.starProfilLinkSelector = ".lavert-cards.abo .star-profile-link"
        this.starsNavigationUsedSelector = ".lavert-cards.abo .star-profile-link"

        this.addEventListeners()
    }

    addEventListeners() {
        /** void */
        $(document).on(
            "mousedown mouseup click",
            this.starProfilLinkSelector,
            this.saveStarProfileCalledFromMyStars.bind(this),
        )

        $(document).on(
            "mousedown mouseup click",
            this.starsNavigationUsedSelector,
            function () {
                this.myStarsNavigationUsedCookie.expires = Cookie.getExpireDate(3600)
                this.myStarsNavigationUsedCookie.value = "1"
            }.bind(this),
        )
    }

    saveStarProfileCalledFromMyStars(event) {
        this.starProfileCalledFromMyStarsCookie.expires = Cookie.getExpireDate(3600)
        this.starProfileCalledFromMyStarsCookie.value = event.currentTarget.dataset.starId
    }
}
